import { SELECTED_AUDIO_INPUT_KEY } from '../constants';
import { useDevices, useMediaContext } from '../MediaContext';
import { useIsTrackEnabled } from './useIsTrackEnabled';
import { useMediaStreamTrack } from './useMediaStreamTrack';
export const useAudioInputList = () => {
    const { localTracks, isAcquiringLocalTracks } = useMediaContext();
    const { audioInputDevices } = useDevices(isAcquiringLocalTracks);
    const localAudioTrack = localTracks.find((track) => track.kind === 'audio');
    const mediaStreamTrack = useMediaStreamTrack(localAudioTrack);
    const localAudioInputDeviceId = mediaStreamTrack === null || mediaStreamTrack === void 0 ? void 0 : mediaStreamTrack.getSettings().deviceId;
    const isTrackEnabled = useIsTrackEnabled(localAudioTrack);
    const activeInput = audioInputDevices.find((device) => device.deviceId === localAudioInputDeviceId);
    function onDeviceSelect(newDeviceId) {
        window.localStorage.setItem(SELECTED_AUDIO_INPUT_KEY, newDeviceId);
        localAudioTrack === null || localAudioTrack === void 0 ? void 0 : localAudioTrack.restart({ deviceId: { exact: newDeviceId } });
    }
    return {
        devices: audioInputDevices.map((device) => {
            return {
                id: device.deviceId,
                label: device.label
            };
        }),
        onDeviceSelect,
        activeInput: {
            enabled: isTrackEnabled,
            label: activeInput === null || activeInput === void 0 ? void 0 : activeInput.label,
            id: activeInput === null || activeInput === void 0 ? void 0 : activeInput.deviceId
        }
    };
};
//# sourceMappingURL=useAudioInputList.js.map